/* 多角度段：捲動進度 0→1 對應「轉一圈」。
   桌機＝捲動刷影片（全關鍵幀 -g 1，任意 seek 都是整格）。
   手機＝Apple 式圖片序列：iOS 不讓「沒真正播放過」的影片刷 currentTime（整塊黑，
   iOS 26 正式版與 27 Beta 都中，play→pause 逼格也救不回）——但換圖畫 canvas
   完全沒問題，Apple 官網的 iPhone 轉品就是這招（73 張 JPG、共約 1.3MB，
   進到附近才開載，比影片 2.2MB 還輕）。
   prefers-reduced-motion 退回自動循環播放。 */
if (!window.__tsViewsInit) {
  window.__tsViewsInit = 1;
  (function () {
    function start() {
      var sec = document.querySelector("[data-ts-viewscrub]");
      if (!sec) return;
      var vid = sec.querySelector("video");
      if (!vid) return;

      if (matchMedia("(prefers-reduced-motion:reduce)").matches) {
        vid.loop = true;
        vid.setAttribute("autoplay", "");
        var pr = vid.play();
        if (pr && pr.catch) pr.catch(function () {});
        return;
      }

      if (matchMedia("(hover:none)").matches && sec.getAttribute("data-frames")) {
        scrubFrames(sec, vid);
      } else {
        scrubVideo(sec, vid);
      }
    }

    /* 進度共用：釘住段（高度 > 一屏）內，段頂捲過多少＝轉多少 */
    function onProgress(sec, cb) {
      var ticking = false;
      function update() {
        ticking = false;
        var vh = innerHeight, r = sec.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var h = sec.offsetHeight - vh;
        var p = (0 - r.top) / (h > 0 ? h : 1);
        if (p < 0) p = 0; else if (p > 1) p = 1;
        cb(p, r, vh);
      }
      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }
      addEventListener("scroll", onScroll, { passive: true });
      addEventListener("resize", onScroll);
      update();
      return update;
    }

    function scrubVideo(sec, vid) {
      vid.pause();
      /* iOS Safari：沒 play 過的影片不渲染畫格——先 play 再立刻 pause 逼出第一格
         （桌機 Safari 也有輕微版本的這毛病，留著無害） */
      function prime() {
        var pr = vid.play();
        if (pr && pr.then) pr.then(function () { vid.pause(); }).catch(function () {});
        else vid.pause();
      }
      if (vid.readyState >= 2) prime();
      else vid.addEventListener("canplay", prime, { once: true });

      var update = onProgress(sec, function (p) {
        if (!vid.duration) return;
        var t = p * (vid.duration - 0.04);
        /* 差距小於一格就不 seek，省掉無謂的解碼 */
        if (Math.abs(vid.currentTime - t) > 0.03) vid.currentTime = t;
      });
      if (vid.readyState < 1) vid.addEventListener("loadedmetadata", update);
    }

    function scrubFrames(sec, vid) {
      var N = parseInt(sec.getAttribute("data-frame-count"), 10) || 73;
      /* data-frames 是第 1 張的 asset_url；去掉 ?v= 版本參數後換序號
         （每個資產的 v 不同，帶著換會 404） */
      var base = sec.getAttribute("data-frames").split("?")[0];
      function url(i) {
        var n = String(i + 1);
        while (n.length < 3) n = "0" + n;
        return base.replace(/001(?=\.jpg$)/, n);
      }

      var box = sec.querySelector(".views__vid");
      var cv = document.createElement("canvas");
      cv.width = 720; cv.height = 720;
      cv.style.cssText = "width:100%;height:auto;display:block";
      cv.setAttribute("role", "img");
      cv.setAttribute("aria-label", vid.getAttribute("aria-label") || "");
      var ctx = cv.getContext("2d");
      vid.remove(); /* 手機不載影片，流量只花在圖片序列上 */
      box.appendChild(cv);

      var imgs = new Array(N), want = 0, cur = -1, started = false;
      function nearest(i) {
        for (var d = 0; d < N; d++) {
          if (imgs[i - d] && imgs[i - d].ok) return i - d;
          if (imgs[i + d] && imgs[i + d].ok) return i + d;
        }
        return -1;
      }
      function draw() {
        var j = nearest(want);
        if (j < 0 || j === cur) return;
        cur = j;
        ctx.drawImage(imgs[j], 0, 0, 720, 720);
      }
      function loadAll() {
        if (started) return;
        started = true;
        for (var i = 0; i < N; i++) {
          (function (i) {
            var im = new Image();
            im.onload = function () { im.ok = true; draw(); };
            im.src = url(i);
            imgs[i] = im;
          })(i);
        }
      }

      onProgress(sec, function (p, r, vh) {
        /* 快到了才開載（差兩個螢幕高以內） */
        if (r.top < vh * 2) loadAll();
        want = Math.round(p * (N - 1));
        draw();
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start);
    } else { start(); }
  })();
}
